<template>
  <v-dialog
    v-model="dialog"
    width="320px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Adjust Policy</span>
          <i
            class="el-icon-close"
            @click="changeDialog"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div class="flex-content">
          <p
            class="tip void-color">Do you need Edit Premium?</p>
          <div class="flex-box">
            <div class="box">
              <v-button @click="handlePremium">Edit Premium</v-button>
              <v-button @click="handleNext">Not Now</v-button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import OMath from '@/utils/math'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'CouponDialog',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed:{
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
      }
    }
  },
  methods: {
    changeDialog(data) {
      this.$emit('input',this.dialog)
    },
    handleNext() {
      this.dialog = false
      this.$emit('input',this.dialog)
      this.$emit('next')
    },
    handlePremium(){
      this.dialog = false
      this.$emit('input',this.dialog)
      this.$emit('premium')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .title-span{
    color: #24292E;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
  }
  .tip{
    color: #586069;
    font-weight: 500;
  }
  .void-color{
    color: #CB2431;
    align-items: center;
    margin-top: 5px;
    span{
      color: #CB2431!important;
      margin-left: 5px;
    }
  }
  .flex-content {
    //width: 280px;
    .padding{
      padding: 10px;
    }
    .flex-box {
      border-radius: 5px;
      //border: 1px solid #E1E4E8;
      //width: 280px;
      margin: 16px 0;
      .el-button{
        width: 100%;
        padding-left: 0;
        margin-left: 0;
        padding: 10px;
        margin-bottom: 15px;
        font-weight: bold;
      }
      .flex-info {
        //display: flex;
        //justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;
      }
    }

  }
}
</style>
